import { Skeleton } from 'primereact/skeleton';
import {
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
} from 'recharts';
import { useMemo } from 'react';

interface DataEntry {
  name: string;
  value: number;
}

interface GrossMoicBarChartProps {
  data: DataEntry[];
  isLoading: boolean;
  error: Error | null;
}

export default function GrossMoicBarChart({
  data,
  error,
  isLoading,
}: GrossMoicBarChartProps) {
  if (isLoading) {
    return (
      <div className="p-3 h-full">
        <Skeleton className="h-full"></Skeleton>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-3 h-full flex justify-content-center align-items-center">
        <div className="p-error">Something went wrong.</div>
      </div>
    );
  }

  const noData = useMemo(() => {
    return !data.length || data.every((entry) => entry.value === 0);
  }, [data]);

  if (noData) {
    return (
      <div className="flex flex-column h-full align-items-center p-3">
        <div className="flex w-full h-2rem">
          <h3 className="text-lg font-semibold mb-4">Gross MOIC</h3>
        </div>
        <div className="align-items-center flex h-full mb-6">
          No data found.
        </div>
      </div>
    );
  }

  const yAxisUpperLimit = Math.max(...data.map((item) => item.value));

  return (
    <div className="p-3">
      <h3 className="text-lg font-semibold mb-4">Gross MOIC</h3>
      <div className="h-20rem">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis
              domain={[0, yAxisUpperLimit + (1 / 5) * yAxisUpperLimit]}
              tickFormatter={(value) => Number(value).toFixed(2)}
            />
            <Tooltip formatter={(value) => Number(value).toFixed(2)} />
            <Bar dataKey="value" fill="#82ca9d" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
